import moment from "@/utils/moment";
import "moment/locale/pt-br";
moment.locale("pt-BR");

export default {
  filters: {
    formatDate(date, type = "DD/MM/Y HH:mm:ss") {
      return moment(date).format(type);
    },

    dateAndTime(date) {
      return moment(date).format("DD/MM/Y [às] HH[h]");
    },

    getDate(date) {
      return moment(date).format("DD/MM/Y");
    },

    greaterDate(dates) {
      var greater = false;

      dates.map(date => {
        greater = greater ? (date > greater ? date : greater) : date;
      });

      return greater;
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/dateMixin.js